import { Outlet, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { Header } from './Header';
import { Footer } from './Footer';
import { SkipLink } from '@/components/common/SkipLink';
import { SmoothScrollProvider } from '@/components/common/SmoothScrollProvider';

export function RootLayout() {
  const location = useLocation();

  return (
    <SmoothScrollProvider>
      <SkipLink />
      <div className="flex min-h-screen flex-col">
        <Header />
        <AnimatePresence mode="wait">
          <motion.main
            key={location.pathname}
            id="main-content"
            className="flex-1"
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.25, ease: 'easeOut' }}
          >
            <Outlet />
          </motion.main>
        </AnimatePresence>
        <Footer />
      </div>
    </SmoothScrollProvider>
  );
}
